import { ReactNode } from 'react';

import { Typography } from 'libs/ui';

import { HeaderStyled } from './Header.styles';

export interface HeaderProps {
  title: string;
  subTitle?: string;
  subTitleContent?: ReactNode;
}

export const Header = ({ title, subTitle, subTitleContent }: HeaderProps) => (
  <HeaderStyled>
    <Typography
      as="h1"
      className="formContainer-title"
      datax="onboarding-title"
      variant="title"
      variantMobile="subtitle"
    >
      {title}
    </Typography>
    {subTitleContent ||
      (!!subTitle && (
        <Typography as="p" datax="onboarding-subtitle" variantMobile="caption">
          {subTitle}
        </Typography>
      ))}
  </HeaderStyled>
);
